import { InverseHeader } from '@jouzen/ecom-components';

import { PopHeroContent } from './PopHeroContent';
import { PopHeroMedia } from './PopHeroMedia';

export function PopHero(): JSX.Element {
  return (
    <InverseHeader enter>
      <section
        className="relative h-svh min-h-[50vw] text-sandstone-200 lg:px-5 lg:pb-4"
        data-cy="pop_hero"
      >
        <div className="relative size-full overflow-hidden pb-24 pt-20 md:pb-16 lg:rounded-b-xl">
          <PopHeroMedia />
          <PopHeroContent />
        </div>
      </section>
    </InverseHeader>
  );
}
